import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'pdf-original-theme',
  templateUrl: './pdf-original.component.html',
  styleUrls: ['./viewer-with-images.css', './ngx-extended-pdf-viewer.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class PdfOriginalComponent {}
